"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const orderPaymentDetailState_1 = require("@/order/payment_detail/orderPaymentDetailState");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/member/setting/components");
const functions_1 = require("@/order/payment_detail/functions");
const components_2 = require("@/order/payment_detail/components");
function default_1({ isPCCChangable, enableChangePCC, }) {
    const paymentDetail = (0, recoil_1.useRecoilValue)(orderPaymentDetailState_1.paymentDetailState);
    const isEditable = (0, functions_1.isPaymentDetailEditable)(paymentDetail);
    const { t } = (0, react_i18next_1.useTranslation)();
    if (isEditable) {
        return ((0, jsx_runtime_1.jsx)(components_1.SettingChangeButton, Object.assign({ sx: { display: isPCCChangable ? 'flex' : 'none' }, onClick: enableChangePCC }, { children: t('수정') })));
    }
    return ((0, jsx_runtime_1.jsx)(components_2.PaymentDetailUneditableDiv, Object.assign({ css: { display: isPCCChangable ? 'flex' : 'none' } }, { children: t('수정 불가') })));
}
exports.default = default_1;
